import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSubmissionDetails } from "../../Services/redux/Application-details/ApplicationDetailsActions";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ApplicationDetailsSideMenu from "../../Components/ApplicationDetailsSideMenu/ApplicationDetailsSideMenu";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Button, Container, Grid2, IconButton } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import CloseIcon from "@mui/icons-material/Close";

import Topheader from "../../Layout/header/header";
import { fetchGetClientIds, fetchPostClient, fetchDeleteClient } from "../../Services/redux/GenerateClient/GenerateClientActions";
import { fetchApplicationDetails } from "../../Services/redux/appId-details/AppIdDeatilsActions";
import "./ManageApiClient.css";

function ManageApiClient() {
  const navigate = useNavigate();
  const { appId } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const appData = useSelector((state) => state.applicationDetails.applicationDetails);
  const submissionId = location.state?.submissionId || "";
  const submissionData = useSelector(
    (state) => state.submissionDetails.submissionDetails
  );
  const generalClients = useSelector(
    (state) => state.generalClient.generalClientIds
  );
  const [showSecret, setShowSecret] = useState(false);
  const [showRegenerateToast, setShowRegenerateToast] = useState(false);
  const [toastTriggerCount, setToastTriggerCount] = useState(0);
  const [toastDescription, setToastDescription] = useState("");
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [selectedClientId, setSelectedClientId] = useState("");

  useEffect(() => {
    if (submissionId) {
      if (appId) {
        dispatch(fetchApplicationDetails(appId));
      }
      dispatch(fetchSubmissionDetails(appId, submissionId));
    }
  }, [appId, submissionId, dispatch]);

  useEffect(() => {
    if (appId && globalThis.location.href.includes("api-client")) {
      dispatch(fetchGetClientIds(appId));
    }
  }, [submissionData, appId, dispatch]);

  useEffect(() => {
    if (!showRegenerateToast) {
      return undefined;
    }

    const timeoutId = globalThis.setTimeout(() => {
      setShowRegenerateToast(false);
    }, 7000);

    return () => {
      globalThis.clearTimeout(timeoutId);
    };
  }, [showRegenerateToast, toastTriggerCount]);

  const backToApplications = () => {
    navigate(`/ui/developer/applications/${appId}`, {
      state: {
        teamId: sessionStorage.getItem("teamId"),
        submissionId: submissionId || "",
      },
    });
  };

  const createClient = () => {
    if (appId) {
      dispatch(fetchPostClient(appId));
    }
  };

  const deleteClient = (clientId) => {
    if (appId && clientId) {
      dispatch(fetchDeleteClient(appId));
    }
  };

  const handleOpenDeleteDialog = (clientId) => {
    setSelectedClientId(clientId || "");
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
    setSelectedClientId("");
  };

  const handleConfirmDelete = () => {
    deleteClient(selectedClientId);
    handleCloseDeleteDialog();
  };

  const clientExists =
    generalClients &&
    typeof generalClients === "object" &&
    Object.keys(generalClients).length > 0;

  const clientSecret = generalClients?.clientSecret || "";
  const maskedSecret = useMemo(() => {
    if (!clientSecret) {
      return "";
      }

    if (clientSecret.length <= 10) {
      return `${clientSecret.slice(0, 4)}******`;
    }

    return `${clientSecret.slice(0, 24)}****************`;
  }, [clientSecret]);

  const copyToClipboard = async (value) => {
    if (!value) {
      return;
    }

    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(value);
      }
    } catch (error) {
     console.log("Failed to copy to clipboard:", error);
    }
  };

  const handleCreateClient = () => {
    createClient();

    if (clientExists) {
      setToastDescription(
        "A new ID and Secret have been created, and the existing ones have been permanently removed."
      );
    } else {
      setToastDescription(
        "Client secret is only one time visible after creating only."
      );
    }

    setShowRegenerateToast(true);
    setToastTriggerCount((prev) => prev + 1);
  };

  return (
    <div>
      {showRegenerateToast && (
        <output className="api-client-regenerate-toast" aria-live="polite">
          <div className="api-client-regenerate-toast-title">New Credentials Generated</div>
          <div className="api-client-regenerate-toast-description">
            {toastDescription}
          </div>
        </output>
      )}

      {isDeleteDialogOpen && (
        <div className="api-client-delete-dialog-overlay">
          <button
            type="button"
            aria-label="Close delete dialog backdrop"
            className="api-client-delete-dialog-backdrop"
            onClick={handleCloseDeleteDialog}
          />
          <dialog
            className="api-client-delete-dialog"
            open
            aria-labelledby="delete-api-client-title"
          >
            <div className="api-client-delete-dialog-header">
              <h2 id="delete-api-client-title">Delete API Client</h2>
              <IconButton
                aria-label="close delete dialog"
                onClick={handleCloseDeleteDialog}
                size="small"
              >
                <CloseIcon />
              </IconButton>
            </div>
            <p className="api-client-delete-dialog-body">
              Deleting this client will permanently revoke access to the
              application. Please note that the secret key cannot be recovered
              once this dialog is closed. Are you sure you want to proceed?
            </p>
            <div className="api-client-delete-dialog-actions">
              <Button
                className="api-client-delete-cancel-btn"
                onClick={handleCloseDeleteDialog}
              >
                Cancel
              </Button>
              <Button
                className="api-client-delete-confirm-btn"
                onClick={handleConfirmDelete}
              >
                Delete
              </Button>
            </div>
          </dialog>
        </div>
      )}

      <Topheader />
      <Container
        maxWidth="lg"
        sx={{ width: "100% !important", maxWidth: "100% !important" }}
      >
        <Grid2 container>
          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
            <div className="container-my-release">
              <div
                className="side-menu-my-release"
                style={{ marginTop: "69px" }}
              >
                <button
                  className="arrow-back"
                  onClick={backToApplications}
                  style={{ background: "none", border: "none", padding: 0, cursor: "pointer", display: "flex", alignItems: "center" }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <ArrowBackIcon style={{ color: " #717273" }} />
                  </div>
                  <div className="my-apps">Back To App Details</div>
                </button>
                {appData && Object.keys(appData).length > 0 && (
                  <ApplicationDetailsSideMenu appData={appData} appMultiSubmissionId={submissionId} />
                )}
              </div>

              <div className="manage-api-client-content">
                <div
                  className="listing-header-wrapper-all-release"
                  style={{
                    borderBottom: "1px solid  #12141533",
                    width: "100%",
                  }}
                >
                  {submissionData && Object.keys(submissionData).length > 0 && appData && Object.keys(appData).length > 0 && (
                    <div className="app-icon-my-release">
                      <div className="icon-name-my-release">
                        <img
                          style={{ borderRadius: "4px" }}
                          src={submissionData.icon.url}
                          alt={submissionData.fileName}
                          width={60}
                          height={60}
                        />
                        {
                          <div className="name-status-my-release">
                            <p className="application-name">
                              {appData.name}
                            </p>
                          </div>
                        }
                      </div>
                    </div>
                  )}
                </div>

                <div className="all-release-body api-client-header-body">
                  <div className="api-client-heading-block">
                    <p className="all-release-text api-client-title-text">
                      {clientExists ? "API Client" : "No API Clients for this application"}
                    </p>
                    <p className="release-text-all-release api-client-subtitle-text">
                      Generate client software IDs to allow access to the
                      application listing
                    </p>
                  </div>
                  <div className="api-client-generate-action">
                    <Button
                      sx={{
                        border: "1px solid #0476E2",
                        fontWeight: "400",
                        color: "#0476E2 !important",
                        fontSize: "12px !important",
                        letterSpacing: "0.4px !important",
                        lineHeight: "19.6px",
                        textTransform: "none !important",
                      }}
                      onClick={handleCreateClient}
                    >
                      {clientExists ? "Regenerate" : "Generate"}
                    </Button>
                  </div>
                </div>

                <div className="api-client-card-wrap">
                  {clientExists ? (
                    <div className="api-client-card">
                      <div className="api-client-delete-action">
                        <IconButton
                          aria-label="delete client"
                          onClick={() => handleOpenDeleteDialog(generalClients.clientId)}
                          size="small"
                        >
                          <DeleteOutlineIcon fontSize="small" />
                        </IconButton>
                      </div>

                      <div className="api-client-label">Client ID:</div>
                      <div className="api-client-value-row">
                        <span className="api-client-value">{generalClients.clientId}</span>
                        <IconButton
                          aria-label="copy client id"
                          onClick={() => copyToClipboard(generalClients.clientId)}
                          size="small"
                        >
                          <ContentCopyIcon fontSize="small" />
                        </IconButton>
                      </div>
                      {clientSecret && (
                        <>
                      <div className="api-client-label">Secret:</div>
                      <div className="api-client-value-row">
                        <span className="api-client-value">
                          {showSecret ? clientSecret : maskedSecret}
                        </span>
                        <IconButton
                          aria-label="toggle secret visibility"
                          onClick={() => setShowSecret((prev) => !prev)}
                          size="small"
                        >
                          {showSecret ? (
                            <VisibilityOutlinedIcon fontSize="small" />
                          ) : (
                            <VisibilityOffOutlinedIcon fontSize="small" />
                          )}
                        </IconButton>
                        <IconButton
                          aria-label="copy client secret"
                          onClick={() => copyToClipboard(clientSecret)}
                          size="small"
                        >
                          <ContentCopyIcon fontSize="small" />
                        </IconButton>
                      </div>
                      </>
                      )
                      }
                    </div>
                  ) : (
                    <div>
                      <p>No clients found.</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Grid2>
        </Grid2>
      </Container>
    </div>
  );
}

export default ManageApiClient;
